import { isSameSecond, isValid } from 'date-fns';
import { isNil } from 'lodash';

/**
 * Compares the editor date to the external date and returns true if they are different.
 */
export const isEditorDateDifferentFromExternalDate = (
  editor: Date | undefined,
  external: Date | undefined
) => {
  // If both are undefined, nothing changed
  if (isNil(editor) && isNil(external)) {
    return false;
  }

  // If only one is undefined, something changed
  if (isNil(external) || isNil(editor)) {
    return true;
  }

  // If either are invalid, nothing changed
  if (!isValid(editor) || !isValid(external)) {
    return false;
  }

  // If they are the same, nothing changed
  return !isSameSecond(editor, external);
};
